import { render, staticRenderFns } from "./StudentInfoReport.vue?vue&type=template&id=ecee8812&scoped=true"
import script from "./StudentInfoReport.vue?vue&type=script&lang=js"
export * from "./StudentInfoReport.vue?vue&type=script&lang=js"
import style0 from "./StudentInfoReport.vue?vue&type=style&index=0&id=ecee8812&prod&scoped=true&lang=scss"
import style1 from "./StudentInfoReport.vue?vue&type=style&index=1&id=ecee8812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecee8812",
  null
  
)

export default component.exports